import {
	PhoneNumberUtil,
	type PhoneNumber,
	PhoneNumberFormat as PNF,
} from 'google-libphonenumber'

const phoneUtil = PhoneNumberUtil.getInstance()
const getPhoneCountryCode = (
	phone: PhoneNumber | string,
	defaultCountryCode: string = 'US'
): string => {
	let callingCountryCode
	try {
		if (typeof phone === 'string') {
			phone = phoneUtil.parse(phone)
		}
		callingCountryCode = phoneUtil.getRegionCodeForNumber(phone)
	} catch (e) {
		// handle error
	}
	return callingCountryCode ?? defaultCountryCode
}

const isValidPhoneNumberForRegion = (
	phone: PhoneNumber | string,
	region: string = 'US'
): boolean => {
	let isValid = false
	try {
		if (typeof phone === 'string') {
			phone = phoneUtil.parse(phone, region)
		}
		isValid = phoneUtil.isValidNumberForRegion(phone, region)
	} catch (e) {
		// handle error
		return isValid
	}

	return isValid
}

const formatPhoneNumber = (
	phone: string,
	countryCode?: string,
	formatter: PNF = PNF.NATIONAL
): string | undefined => {
	let formattedPhone = phone
	if (isValidPhoneNumberForRegion(formattedPhone, countryCode)) {
		const number = phoneUtil.parse(phone, countryCode)
		formattedPhone = phoneUtil.format(number, formatter)
		return formattedPhone
	}
	return formattedPhone.replace(/[^0-9]/g, '')
}

export default {
	getPhoneCountryCode,
	isValidPhoneNumberForRegion,
	formatPhoneNumber,
}
